import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

// Returns the stored Audit (same shape as getTailoredAudits items) so callers can update their
// display immediately instead of waiting for the invalidation-driven refetch (FIQ-682)
export const updateTailoredAuditRejection = api(function updateTailoredAuditRejection(auditId, reason) {
    return mutate(
        gql`
            mutation UpdateTailoredAuditRejection($auditId: String!, $reason: String!) {
                updateTailoredAuditRejection(auditId: $auditId, reason: $reason) {
                    id
                    shortDescription
                    longDescription
                    referenceId
                    type
                    date
                    userId
                    userName
                    payload
                }
            }
        `,
        { auditId, reason },
        { returns: "updateTailoredAuditRejection" }
    )
})
